import type { AppThunk } from '@packages/shared/core/common/store';
import { normalizeError } from '@packages/shared/core/common/utils/errors';
import type { FormSubmissionParams } from '../entities';
import { submitSupportFormPending, submitSupportFormSucceed, submitSupportFormFailed } from './actions';

export const submitSupportForm =
  (params: FormSubmissionParams, attachments: Array<File> = []): AppThunk =>
  async (dispatch, getState, extra) => {
    const { supportFormService, logger } = extra;

    try {
      dispatch(submitSupportFormPending());

      await supportFormService.submitSupportForm(params, attachments);

      dispatch(submitSupportFormSucceed());
    } catch (err) {
      const errorMessage = 'Failed to submit form. Please refresh the page or try again later.';
      const normalizedError = normalizeError(err);

      logger.error(normalizedError);
      dispatch(submitSupportFormFailed(errorMessage));
    }
  };
